<script setup lang="ts">
import type { MaskInputOptions } from 'maska';
import { vMaska } from 'maska/vue';
import { reactive } from 'vue';

import { type FieldProps, useFieldValidation } from '@/composables/useFieldValidation';

const maskOptions: MaskInputOptions = reactive({
  mask: '(###) ###-####',
  tokens: {
    '#': { pattern: /[0-9]/ }
  },
  eager: true,
});

const props = defineProps<FieldProps>();

const {
  value: phoneValue,
  errorMessage,
  handlers,
  fieldId,
  isDisabled,
  computedLabel: label
} = useFieldValidation(props, 'Téléphone');
</script>

<template>
  <div class="fieldBlock fieldBlock_phone">
    <label :for="fieldId">
      {{ label }}
    </label>
    <input :id="fieldId"
           v-model="phoneValue"
           v-maska="maskOptions"
           type="tel"
           :aria-invalid="!!errorMessage"
           :disabled="isDisabled"
           v-on="handlers">
    <div class="fieldBlock-extraInfo">
      <span v-if="errorMessage"
            class="fieldBlock-error">{{ errorMessage }}</span>
      <span v-if="props.hint"
            class="fieldBlock-hint">
        {{ props.hint }}
      </span>
    </div>
  </div>
</template>
